































import { DashboardVendedorResumoVendas } from "@/services/dashboard-vendedor.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class WidgetResumoVendasVendedor extends Vue {
  @Prop({ required: true })
  readonly resumoVendas!: DashboardVendedorResumoVendas;
}
